import React from 'react';
import {Subheading} from 'app/styles/heading';
import MetricTiles from 'app/components/metricTiles/MetricTiles';
import {round} from 'app/helpers/helpers';
import MetricTile from 'app/components/metricTiles/MetricTile';
import styled from 'styled-components';
import {Placeholder, SIZES, Typography} from '@fupa/fupa-uikit';

const CustomPlaceholder = styled(Placeholder)`
  &&& {
    padding: ${SIZES['16']} ${SIZES['16']} 0 ${SIZES['16']};
    ${props => props.theme.desktopLayout`
      box-sizing: border-box
   `}
  }
`;

const PlayerStats = ({stats}) => {
  const facts = [
    [stats.goals && stats.matches ? round(stats.goals / stats.matches, 1) : '–', 'Tore/Spiel'],
    [stats.minutes && stats.matches ? round(stats.minutes / stats.matches, 0) : '–', 'Minuten/Spiel'],
    [
      stats.matches && stats.team_matches ? `${round((stats.matches / stats.team_matches) * 100, 2)}%` : '–',
      'Einsatzquote',
    ],
  ];

  const topFacts = facts.map((fact, index) => (
    <MetricTile key={fact[1]} value={fact[0]} label={fact[1]} index={index} />
  ));

  const TopFactsContent = stats.errorMessage ? (
    <CustomPlaceholder>
      <Typography variant='caption1'>{stats.errorMessage}</Typography>
    </CustomPlaceholder>
  ) : (
    <MetricTiles>{topFacts}</MetricTiles>
  );

  return (
    <React.Fragment>
      <Subheading variant='subheading2'>Spieler-Facts</Subheading>
      {TopFactsContent}
    </React.Fragment>
  );
};

export {PlayerStats};
